export default __webpack_public_path__ + "static/media/Snd3.7babf533.mp3";